import { FormattedMessage } from 'react-intl';
import { Spacer } from '@tink/core/src/components/atoms/Spacer/Spacer';
import { ProviderField } from '../../../../../../../models/provider';
import { ContentBody } from '../../../../../../atoms/ContentBody/ContentBody';
import { Button } from '../../../../../../atoms/Button/Button';
import { Footer } from '../../../../../../atoms/Footer/Footer';
import {
  ProviderInputs as ProviderInputsImport,
  ProviderInputsPresenterProps,
  SubmitProviderInputsPayload,
} from '../../../../../SubmitCredentials/molecules/ProviderInputs/ProviderInputs';
import { messages } from '../../messages';
import { useCredentialsCopy } from '../../../../../SubmitCredentials/hooks/useCredentialsCopy';
import { H1 } from '../../../../../../atoms/Heading/Heading';

export type MultipleFieldsViewProps = {
  fields: ProviderField[];
  isButtonDisabled: boolean;
  setIsButtonDisabled: (value: boolean) => void;
  onSubmit: (values: SubmitProviderInputsPayload) => void;
  ProviderInputs?: React.ComponentType<ProviderInputsPresenterProps>;
};

export const MultipleFieldsView = ({
  fields,
  isButtonDisabled,
  setIsButtonDisabled,
  onSubmit,
  ProviderInputs = ProviderInputsImport,
}: MultipleFieldsViewProps) => {
  const { heading } = useCredentialsCopy();

  return (
    <ContentBody data-testid="multiple-fields-template">
      <H1 mb="xxsmall">{heading}</H1>
      <ProviderInputs
        providerFields={fields}
        setButtonDisabled={setIsButtonDisabled}
        onSubmit={onSubmit}
      >
        <Spacer size="normal" />

        <Footer stickToBottom>
          <Button disabled={isButtonDisabled} type="submit" color="primary" variant="contained">
            <FormattedMessage {...messages.submit} />
          </Button>
        </Footer>
      </ProviderInputs>
    </ContentBody>
  );
};
